import Vue from 'vue'
import VueRouter from 'vue-router'
import view from '@/page/index/view.vue'
import aboutlanyve from '@/page/aboutlanyve/index.vue'
import x15 from '@/page/product/X15/index.vue'
import smartDevice from '@/page/product/smartDevice/index.vue'
import UAVControlPlatform from '@/page/product/UAVControlPlatform/index.vue'
import FlyingPlatform  from '@/page/FlyingPlatform/index.vue'
import SmartPolicing from '@/page/solution/SmartPolicing/index.vue'
import ControlSystem from '@/page/product/ControlSystem/index.vue'
import PersonalizedCustomization from '@/page/product/PersonalizedCustomization/index.vue'
import ForestryFirefighting from  '@/page/solution/ForestryFirefighting/index.vue'
import PowerInspection from  '@/page/solution/PowerInspection/index.vue'
import NuclearIndustryRobot from '@/page/solution/NuclearIndustryRobot/index.vue'
import Radar from '@/page/product/Radar/index.vue'
import InformationCenter from '@/page/ResourceCenter/InformationCenter/index.vue'
import VideoCenter from '@/page/ResourceCenter/VideoCenter/index.vue'
import DownloadCenter from '@/page/ResourceCenter/DownloadCenter/index.vue'
import EducationSection from '@/page/ResourceCenter/EducationSection/index.vue'
import EducationSection1 from '@/page/ResourceCenter/EducationSection1/index.vue'

Vue.use(VueRouter);

function isMobile() {
  return window.innerWidth < 768;  // 这里的阈值可以根据需求调整
}


const router = new VueRouter({
    mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
   
      return { x: 0, y: 0 };
    
  },
  routes: [
    {
      path: '/',
      component: isMobile()
      ? ()=> import('@/page/mobile_page/index/index.vue')
      : view,
      meta: { 
        title: '蓝悦无人机技术有限公司 - 智能控制系统及无人机供应商',
        description: '蓝悦无人机技术有限公司是集智能控制系统自研、无人机整机研发、智能算法与数据平台开发于一体的高新技术企业。提供从警用、消防到电力巡检的全行业无人机解决方案，拥有百余项专利，核心技术自主可控。',
        keywords: '无人机公司，无人机整机研发，智能控制系统，无人机解决方案，工业无人机、多旋翼无人机'
       }
    },
     {
      path: '/FlyingPlatform',
      component: isMobile()
      ?() => import('@/page/mobile_page/FlyingPlatform/view.vue')
      : FlyingPlatform,
      meta: { 
        title: '无人机飞行平台 - 多旋翼/复合翼/直升机/飞控/雷达',
        description: '蓝悦提供全谱系无人机平台：X15多旋翼无人机、GZ500共轴直升机、自研飞控计算机及毫米波避障雷达。产品载荷覆盖300g至300kg，适用于各类高端行业应用。',
        keywords: '多旋翼无人机，共轴无人直升机，无人机飞控，毫米波雷达，无人机载荷'
       }
    },
    {
      path: '/FranchiseCenter',
      component: isMobile()
      ?() => import('@/page/mobile_page/FranchiseCenter/view.vue')
      : ()=> import('@/page/FranchiseCenter/index.vue'),
      meta: { 
        title: '蓝悦无人机加盟 - 无人系统服务商加盟',
        description: '蓝悦无人机（LANYVE）是集无人机整机研发、智能系统开发、无人机应用开发为一体的新型无人机技术企业。',
      }
    },
    {
      path: '/about',
      component: isMobile()
      ?() => import('@/page/mobile_page/aboutview/view.vue')
      : aboutlanyve,
      meta: { 
        title: '关于蓝悦,蓝悦无人机 - 十年技术沉淀的无人机整机研发企业',
        description: '蓝悦无人机（LANYVE）始于2017年，团队源自西工大等高校。我们专注于无人机飞控、结构、仿真全链路技术，拥有西安研发中心和苏州生产基地，致力于成为全球领先的无人系统服务商。',
        keywords: '蓝悦无人机，LANYVE，无人机研发公司，无人机企业简介，高新技术企业'
       }
    },
    {
      path: '/x15',
      component: isMobile()
      ?()=> import('@/page/mobile_page/X15/view.vue')
      : x15,
      meta: { 
        title: '无人机飞行平台 - 多旋翼/复合翼/直升机/飞控/雷达',
        description: '蓝悦提供全谱系无人机平台：X15多旋翼无人机、GZ500共轴直升机、自研飞控计算机及毫米波避障雷达。产品载荷覆盖300g至300kg，适用于各类高端行业应用。',
        keywords: '多旋翼无人机，共轴无人直升机，无人机飞控，毫米波雷达，无人机载荷'
       }
    },
    {
      path: '/smartDevice',
     component: isMobile()
      ?()=> import('@/page/mobile_page/smartDevice/view.vue')
      : smartDevice,
      meta: { 
        title: '智能终端设备 - 蓝悦无人机行业应用载荷',
        description: '蓝悦提供多系列智能终端设备，包括光电吊舱、喊话器、抛投器、探照灯等无人机任务载荷，支持定制化开发，满足警务、消防、巡检等多场景需求。',
        keywords: '无人机载荷，光电吊舱，无人机喊话器，无人机抛投器，智能终端设备，无人机配件'
       }
    },
    {
      path: '/Radar',
      component: isMobile()
      ?()=> import('@/page/mobile_page/Radar/index.vue')
      : Radar,
      meta: { 
        title: '毫米波避障雷达 - 无人机全向感知与安全避障系统',
        description: '蓝悦自研毫米波雷达系统，提供360°全向环境感知、精准障碍物检测与自主避障功能，保障无人机在复杂环境下的飞行安全，适用于城市、林业、电力等场景。',
        keywords: '毫米波雷达，无人机避障，全向感知雷达，无人机安全系统'
       }
    },
    {
      path: '/SmartPolicing',
      component: isMobile()
      ?()=> import('@/page/mobile_page/SmartPolicing/view.vue')
      : SmartPolicing,
       meta: { 
        title: '无人机行业解决方案：警务、消防、电力、巡检',
        description: '基于蓝悦无人机平台与控制系统，为智慧警务、林业消防、电力巡检、工业及核应急领域提供定制化、智能化的无人系统整体解决方案。',
        keywords: '智慧警务解决方案，消防无人机方案，电力巡检无人机，工业巡检方案，无人机应用'
       }
    },
    {
      path: '/ControlSystem',
      component: isMobile()
      ?()=> import('@/page/mobile_page/ControlSystem/index.vue')
      : ControlSystem,
      meta: { 
        title: '无人机飞控系统 - 自主可控的智能飞行控制计算机',
        description: '蓝悦自主研发的无人机飞控系统，支持多旋翼、复合翼、直升机等多种机型，具备自主导航、智能航线规划、实时数据传输等功能，核心技术完全自主可控。',
        keywords: '无人机飞控，飞行控制计算机，自主导航系统，无人机控制系统，飞控算法'
       }
    },
    {
      path: '/PersonalizedCustomization',
      component: isMobile()
      ?()=> import('@/page/mobile_page/PersonalizedCustomization/index.vue')
      : PersonalizedCustomization,
      meta: { 
        title: '无人机行业解决方案：警务、消防、电力、巡检',
        description: '蓝悦提供从需求分析、方案设计到生产制造的全流程定制化服务，支持无人机整机定制、载荷集成、软件开发，满足各行业特殊应用场景需求。',
        keywords: '无人机定制，无人机解决方案，行业定制，私有化部署'
       }
    },
    {
      path: '/UAVControlPlatform',
      component: isMobile()
      ?()=> import('@/page/mobile_page/UAVControlPlatform/index.vue')
      : UAVControlPlatform,
      meta: { 
        title: '无人机管控平台 - 多机协同指挥与数据可视化系统',
        description: '蓝悦无人机管控平台支持多机编队飞行、实时视频监控、任务调度管理、数据分析展示，实现无人机集群的统一指挥调度，提升作业效率与管理水平。',
        keywords: '无人机管控平台，多机协同，无人机指挥系统，数据可视化，集群控制，任务管理'
       }
    },
    {
      path: '/ForestryFirefighting',
      component: isMobile()
      ?()=> import('@/page/mobile_page/ForestryFirefighting/view.vue')
      : ForestryFirefighting,
      meta: { 
        title: '无人机行业解决方案：警务、消防、电力、巡检',
        description: '基于蓝悦无人机平台与控制系统，为智慧警务、林业消防、电力巡检、工业及核应急领域提供定制化、智能化的无人系统整体解决方案。',
        keywords: '智慧警务解决方案，消防无人机方案，电力巡检无人机，工业巡检方案，无人机应用'
       }
    },
    {
      path: '/PowerInspection',
      component: isMobile()
      ?()=> import('@/page/mobile_page/PowerInspection/view.vue')
      : PowerInspection,
      meta: { 
        title: '无人机行业解决方案：警务、消防、电力、巡检',
        description: '基于蓝悦无人机平台与控制系统，为智慧警务、林业消防、电力巡检、工业及核应急领域提供定制化、智能化的无人系统整体解决方案。',
        keywords: '智慧警务解决方案，消防无人机方案，电力巡检无人机，工业巡检方案，无人机应用'
       }
    },
    {
      path: '/NuclearIndustryRobot',
      component: isMobile()
      ?()=> import('@/page/mobile_page/NuclearIndustryRobot/view.vue')
      : NuclearIndustryRobot,
      meta: { 
        title: '无人机行业解决方案：警务、消防、电力、巡检',
        description: '基于蓝悦无人机平台与控制系统，为智慧警务、林业消防、电力巡检、工业及核应急领域提供定制化、智能化的无人系统整体解决方案。',
        keywords: '智慧警务解决方案，消防无人机方案，电力巡检无人机，工业巡检方案，无人机应用'
       }
    },
    {
      path: '/InformationCenter',
      component: isMobile()
      ?()=> import('@/page/mobile_page/InformationCenter/index.vue')
      : InformationCenter,
      meta: { 
        title: '新闻资讯 - 蓝悦无人机最新动态与行业资讯',
        description: '了解蓝悦无人机最新产品发布、技术突破、行业应用案例及公司动态，获取无人机行业前沿资讯与专业见解。',
        keywords: '无人机新闻，行业资讯，蓝悦动态，无人机技术，企业新闻'
       }
    },
    {
      path: '/VideoCenter',
      component: isMobile()
      ?()=> import('@/page/mobile_page/VideoCenter/index.vue')
      : VideoCenter,
      meta: { 
        title: '视频中心 - 蓝悦无人机产品展示与应用案例视频',
        description: '观看蓝悦无人机产品演示、行业应用案例、技术讲解视频，直观了解无人机在警务、消防、电力等领域的实际应用效果。',
        keywords: '无人机视频，产品演示，应用案例，技术讲解，视频教程，无人机实拍'
       }
    },
    {
      path: '/DownloadCenter',
      component: isMobile()
      ?()=> import('@/page/mobile_page/DownloadCenter/index.vue')
      : DownloadCenter,
      meta: { 
        title: '下载中心 - 蓝悦无人机产品手册与技术文档',
        description: '下载蓝悦无人机产品说明书、技术白皮书、用户手册、驱动程序及相关软件资源，获取专业的技术支持资料。',
        keywords: '产品手册，技术文档，用户指南，驱动下载，软件资源，白皮书'
       }
    },
    {
      path:'/EducationSection',
      component: isMobile()
      ?()=> import('@/page/mobile_page/DownloadCenter/index.vue')
      : EducationSection,
      meta: { 
        title: '教育版块 - 蓝悦无人机产品手册与技术文档',
        description: '',
        keywords: ''
       }
    },
        {
      path:'/EducationSection1',
      component: isMobile()
      ?()=> import('@/page/mobile_page/DownloadCenter/index.vue')
      : EducationSection1,
      meta: { 
        title: '教育版块 - 蓝悦无人机产品手册与技术文档',
        description: '',
        keywords: ''
       }
    }
  ]
});

router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  
  // 动态创建或更新meta描述标签
  let metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', to.meta.description || '');
  } else {
    metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    metaDescription.content = to.meta.description || '';
    document.head.appendChild(metaDescription);
  }
  
  // 动态创建或更新meta关键词标签
  let metaKeywords = document.querySelector('meta[name="keywords"]');
  if (metaKeywords) {
    metaKeywords.setAttribute('content', to.meta.keywords || '');
  } else {
    metaKeywords = document.createElement('meta');
    metaKeywords.name = 'keywords';
    metaKeywords.content = to.meta.keywords || '';
    document.head.appendChild(metaKeywords);
  }
  
  next();
});

router.afterEach((to, from) => {
    const appElement = document.getElementById('app');
    if (appElement) {
        appElement.scrollTop = 0;
    }
});

export default router;

